import { CreditReportAccountOverview } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

export const PotentialNegativeInfo = ({
  accounts,
  isNoHit,
  bankruptciesNumber,
  collectionsNumber
}: {
  accounts?: CreditReportAccountOverview[];
  isNoHit: boolean;
  bankruptciesNumber?: number;
  collectionsNumber?: number;
}) => {
  const delinquencies = accounts?.reduce(
    (acc, account) => {
      acc.thirtyDaysDelinquency += Number(account.thirty_days_delinquency) || 0;
      acc.sixtyDaysDelinquency += Number(account.sixty_days_delinquency) || 0;
      acc.ninetyDaysDelinquency += Number(account.ninety_days_delinquency) || 0;
      return acc;
    },
    {
      thirtyDaysDelinquency: 0,
      sixtyDaysDelinquency: 0,
      ninetyDaysDelinquency: 0
    }
  );

  if (isNoHit)
    return (
      <Section sectionTitle="Potential negative info" maxWidth="100%">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Potential negative info" maxWidth="100%">
      <div className="flex justify-between gap-y-3 flex-wrap">
        <div className="flex flex-col gap-y-3">
          <Row
            title="30 Day delinquencies"
            value={delinquencies?.thirtyDaysDelinquency}
          />
          <Row
            title="60 Day delinquencies"
            value={delinquencies?.sixtyDaysDelinquency}
          />
          <Row
            title="90 Day delinquencies"
            value={delinquencies?.ninetyDaysDelinquency}
          />
        </div>
        <div className="flex flex-col gap-y-3">
          <Row title="Bankruptcies" value={bankruptciesNumber} />
          <Row title="Collections" value={collectionsNumber} />
        </div>
      </div>
    </Section>
  );
};
